// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PayInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PayInput — body for POST /subscriptions/pay.
 *
 * franquia_id is the ONLY field, on purpose. Unlike subscribe(), this door does
 * not let the caller pick anything: the plan, the price row and the gateway are
 * already recorded on the live subscription being paid, and re-deriving them
 * from user input would let a franchise in carência quietly change what it owes.
 * The controller resolves all three from the subscription row.
 *
 * PCI note: no card/cartao/cvv/pan/token field may ever be added here.
 */
import { registerContract } from './validate'

export interface Subscriptions_PayInput {
franquia_id: number
}

registerContract('Subscriptions_PayInput', {
  franquia_id: { type: 'number',  required: true },
})
